import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { contact } from './contact';
import { RoomReservation } from '../types/entities/RoomReservation';
import { statuses } from './statuses';
import { roomType } from './roomType';
import { accommodationReservation } from './accommodationReservation';
import { DateField } from '../components/Table/fields/DateField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { FloatField } from '../components/Table/fields/FloatField';

export const roomReservation: SchemaWithClient<RoomReservation> = {
  name: 'Room Reservation',
  pluralName: 'Room Reservation',
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
    },
    accommodation_reservation: {
      name: 'Accommodation Reservation',
      fieldRenderer: SelectField.tableAdapter(accommodationReservation()),
      switchboard: true,
      url: accommodationReservation().client.getAllPath,
      tempSchema: accommodationReservation(),
    },
    room_type: {
      name: 'Room Type',
      fieldRenderer: SelectField.tableAdapter(roomType),
      switchboard: true,
      url: roomType.client.getAllPath,
      tempSchema: roomType,
    },

    reservation_status: {
      name: 'Reservation Status',
      fieldRenderer: SelectField.tableAdapter(statuses.reservationStatus),
      switchboard: true,
      url: contact.client.getAllPath,
      tempSchema: contact,
    },
    cost_currency: {
      name: 'Cost Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    selling_price_currency: {
      name: 'Selling Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    room_count: {
      name: 'Room Count',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    room_size: {
      name: 'Room Size',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    arrival: {
      name: 'Arrival',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    departure_date: {
      name: 'Departure Date',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    breakfast: {
      name: 'Breakfast',
      fieldRenderer: BooleanField,
      fieldType: 'boolean',
    },
    cost: {
      name: 'Cost',
      fieldRenderer: FloatField,
      fieldType: 'float',
    },
    selling_price: {
      name: 'Selling Price',
      fieldRenderer: FloatField,
      fieldType: 'float',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/room-reservations'),
};
